import { render, staticRenderFns } from "./SntSelectProduct.vue?vue&type=template&id=881c9c0e&"
import script from "./SntSelectProduct.vue?vue&type=script&lang=js&"
export * from "./SntSelectProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports